'use client';

import { Box, Tab, Tabs as MuiTabs } from '@mui/material';
import React, { FC, useMemo, useState } from 'react';

import { mergeStyleParts, mergeSx } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

import { TabsProvider } from './tabs.context';
import { centerAlignmentStyles, tabsBaseStyleParts } from './tabs.styling';
import { TabsProperties } from './tabs.types';

export const Tabs: FC<TabsProperties> = ({
  aemAttributes,
  styleParts = {},
  model,
  children,
}) => {
  const { alignment, ':items': aemItems = {} } = model;

  const [value, setValue] = useState<number>(0);

  const tabTitles = useMemo(() => {
    return Object.values(aemItems).map((item) => {
      const { tabTitle = '' } = item as { tabTitle?: string };
      return tabTitle;
    });
  }, [aemItems]);

  const selectedTabTitle = tabTitles[value] || '';

  const handleChange = (_event: React.SyntheticEvent, newIndex: number) => {
    setValue(newIndex);
  };
  return (
    <TabsProvider value={{ selectedTabTitle }}>
      <Box
        {...aemAttributes}
        data-testid="tabs-container"
        data-aue-type="container"
        sx={mergeStyleParts(tabsBaseStyleParts, styleParts, 'root')}
      >
        <Box sx={mergeStyleParts(tabsBaseStyleParts, styleParts, 'wrapper')}>
          <Box sx={mergeSx(tabsBaseStyleParts.divider, styleParts.divider)}>
            <MuiTabs
              data-testid="tabs-list"
              variant="scrollable"
              scrollButtons={false}
              value={value}
              onChange={handleChange}
              aria-label="custom tabs"
              sx={
                {
                  ...mergeStyleParts(
                    tabsBaseStyleParts,
                    styleParts,
                    'tabsList',
                  ),
                  ...(alignment === 'center' ? centerAlignmentStyles : {}),
                } as AbgSxProps
              }
            >
              {tabTitles?.map((label, index) => (
                <Tab
                  data-testid="tab-title"
                  key={`tab-${label}-${index}`}
                  label={label}
                  disableRipple
                  sx={mergeStyleParts(tabsBaseStyleParts, styleParts, 'tab')}
                />
              ))}
            </MuiTabs>
          </Box>
          <Box data-testid="tabs-content">{children}</Box>
        </Box>
      </Box>
    </TabsProvider>
  );
};
